import { render, staticRenderFns } from "./orderDIFOTSlowCollectorsWidget.vue?vue&type=template&id=7150fea8&"
import script from "./orderDIFOTSlowCollectorsWidget.vue?vue&type=script&lang=js&"
export * from "./orderDIFOTSlowCollectorsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports